module.exports = "img/photo22.f0ca73.jpg";